module.exports = __webpack_public_path__ + "static/media/26.cad1fc1f.png";